import React from "react"
import {twMerge} from "tailwind-merge"

export const DashboardCard: React.FC<{
  title: React.ReactNode
  subtitle?: React.ReactNode
  action?: React.ReactNode
  className?: string
  children?: React.ReactNode
}> = ({title, subtitle, action, className, children}) => (
  <section className={twMerge("flex flex-col card-shadow border-cr-blue-light px-[20px] py-[18px]", className)}>
    <div className={"flex items-start justify-between gap-3"}>
      <h2 className={"text-[12px] font-bold tracking-[0.9px] text-cr-slate-90 uppercase"}>{title}</h2>
      {action != null && <div className={"shrink-0"}>{action}</div>}
    </div>
    {subtitle != null && <p className={"mt-[2px] text-[11.5px] text-cr-slate-60"}>{subtitle}</p>}
    {children}
  </section>
)
